"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sparkle = void 0;

function sparkle(element, opts) {
  var _ref = opts || {},
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0.1 : _ref$padding;

  var bounds = element.getBoundingClientRect();
  var xPadding = bounds.width * padding;
  var yPadding = bounds.height * padding;
  var xBounds = [bounds.x + xPadding, bounds.x + bounds.width - xPadding * 2];
  var yBounds = [bounds.y + yPadding, bounds.y + bounds.height - yPadding * 2];
  var averageSize = Math.max(bounds.x, bounds.y) * 0.035; // 3.5% of the element max dimension

  var numSparkles = 1 + Math.floor(Math.max(bounds.x, bounds.y) * 0.005);
  var cancelFns = [];

  var _loop = function _loop(i) {
    var timeout = setTimeout(function () {
      cancelFns.push(createSparklesLoop(xBounds, yBounds, averageSize, opts));
    }, i * 200);
    cancelFns.push(function () {
      return clearTimeout(timeout);
    });
  };

  for (var i = 0; i < numSparkles; i++) {
    _loop(i);
  }

  return function () {
    var _iterator = _createForOfIteratorHelper(cancelFns),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cancel = _step.value;
        cancel();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
}

exports.sparkle = sparkle;

function createSparklesLoop(xBounds, yBounds, averageSize, opts) {
  var x = xBounds[0] + Math.random() * (xBounds[1] - xBounds[0]);
  var y = yBounds[0] + Math.random() * (yBounds[1] - yBounds[0]);

  var currentCancel = function currentCancel() {};

  currentCancel = createSparkle(x, y, averageSize, opts, function () {
    currentCancel = createSparklesLoop(xBounds, yBounds, averageSize, opts);
  });
  return function () {
    currentCancel();
  };
}

function createSparkle(x, y, size) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? '#FFF' : _ref2$color;

  var completeCallback = arguments.length > 4 ? arguments[4] : undefined;
  var particle = document.createElement('particle');
  document.body.appendChild(particle);
  var random = Math.random() * 0.5 + 0.5; // 50% - 150%

  var calculatedSize = size * random;
  particle.style.width = "".concat(calculatedSize, "px");
  particle.style.height = "".concat(calculatedSize, "px");
  particle.style.left = "".concat(x - calculatedSize / 2, "px");
  particle.style.top = "".concat(y - calculatedSize / 2, "px");
  particle.style.borderRadius = '0';
  particle.style.background = color;
  var targetOpacity = 0.95 * random; // More opaque as gets larger

  var rotation = 45 * random;
  var animation = particle.animate([{
    transform: "scale(0) rotate(".concat(rotation, "deg)"),
    opacity: 0
  }, {
    transform: "scale(0) rotate(".concat(rotation, "deg)"),
    opacity: 0,
    offset: 0.4
  }, {
    transform: "scale(1) rotate(".concat(rotation, "deg)"),
    opacity: targetOpacity,
    offset: 0.5
  }, {
    transform: "scale(1) rotate(".concat(rotation, "deg)"),
    opacity: targetOpacity,
    offset: 0.9
  }, {
    transform: "scale(0) rotate(".concat(rotation, "deg)"),
    opacity: 0,
    offset: 1
  }], {
    duration: 2000 + 5000 * random,
    easing: 'ease-in-out'
  });

  animation.onfinish = function () {
    particle.remove();
    completeCallback();
  };

  return function () {
    animation.cancel();
    particle.remove();
  };
}